export enum NbaPlayerStatsOption {
    Points = 'points',
    Min = 'min',
    Fgm = 'fgm',
    Fga = 'fga',
    Fgp = 'fgp',
    Ftm = 'ftm',
    Fta = 'fta',
    Ftp = 'ftp',
    Tpm = 'tpm',
    Tpa = 'tpa',
    Tpp = 'tpp',
    OffReb = 'offReb',
    DefReb = 'defReb',
    TotReb = 'totReb',
    Assists = 'assists',
    PFouls = 'pFouls',
    Steals = 'steals',
    Turnovers = 'turnovers',
    Blocks = 'blocks',
    PlusMinu = 'plusMinus'
}